import React from 'react';
import { Link } from 'react-router-dom';


function PageNotFound() {
  return (
    <div className="notfound-wrapper d-flex align-items-center justify-content-center text-center">
      <div className="container">
        <h1 className="notfound-title">404</h1>
        <h2 className="notfound-subtitle">Oops! Page Not Found</h2>
        <p className="notfound-text">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary mt-3">
          Go Back Home
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
